import { useMemo, useState, useEffect } from "react";
import {
  useAllPrismicDocumentsByType,
  usePrismicDocumentByUID,
  usePrismicDocumentsByType,
  usePrismicDocumentsByUIDs,
} from "@prismicio/react";
import { AUTHORS, LESSON, MASTER_COURSES } from "../config/constants";
import UserUtils from "../utils/user.utils";
import _map from "lodash/map";
import _get from "lodash/get";

const usePlanInfo = (plan) => {
  const [allMasterCourses]        = usePrismicDocumentsByType(MASTER_COURSES);
  const [allAuthors]              = useAllPrismicDocumentsByType(AUTHORS);
  const planSlug                  = _get(plan, 'planData.externalContentSlug', '');
  const masterCourseContent       = _get(allMasterCourses, 'results', []);
  const [planInfo, setPlanInfo]   = useState();
  const [isLoading, setIsLoading] = useState(true);

  const planMasterCourse = useMemo(
    () => masterCourseContent.find((mc) => mc.uid === planSlug),
    [masterCourseContent, planSlug]
  );
  const prismicPlanAuthors     = _get(planMasterCourse, '[0].data.authors', []);
  const prismicPlanLessons     = _get(planMasterCourse, '[0].data.lessons', []);
  const nextWorkoutSlug        = _get(planMasterCourse, '[0].nextWorkout.externalContentSlug', '');

  const [authors] = usePrismicDocumentsByUIDs(
    AUTHORS,
    _map( prismicPlanAuthors, "author.slug" )
  );

  const lesson = useMemo(
    () =>
      prismicPlanLessons.find((item) => {
        return (_get(item, 'lesson.uid') === nextWorkoutSlug);
      }),
    [
      prismicPlanLessons,
      nextWorkoutSlug,
    ]
  );

  const [lessonInfo] = usePrismicDocumentByUID(
    LESSON,
    _get(lesson, 'lessons.uid')
  );

  useEffect(() => {
    const planInfo = {
      ...planMasterCourse,
      ...planInfo?.planData,
      nextWorkout: {
        ...lessonInfo,
        ...planInfo?.planData?.nextWorkout
      },
    };
    setPlanInfo(planInfo);
  }, [
    planMasterCourse,
    planInfo?.planData,
    planInfo?.planData?.nextWorkout,
    lessonInfo,
  ]);

  useEffect(() => {
    if (!!lessonInfo) {
      setIsLoading(false);
    }
  }, [lessonInfo]);

  return { authors, allMasterCourses, planInfo, lessonInfo, allAuthors, isLoading };
}

export default usePlanInfo;
